/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Buffer } from 'buffer';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

// @ts-ignore Fix
window.Buffer = window.Buffer || Buffer;
window.moment = moment;
